const Provider = () => import('./Provider.vue')

const List = () => import('./pages/List.vue')
const Create = () => import('./pages/Create.vue')
const Edit = () => import('./pages/Edit.vue')

const routes = {
  component: Provider,
  path: '/fornecedores',
  meta: {
    label: 'Fornecedores'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'providersList',
      meta: {
        label: 'Gerenciar Fornecedores',
        requiredPermission: {resource: 'provider', value: 'view'}
      }
    },
    {
      path: 'cadastro',
      component: Create,
      name: 'providerCreate',
      meta: {
        hidden: true,
        label: 'Cadastrar',
        requiredPermission: {resource: 'provider', value: 'manage'}
      }
    },
    {
      path: 'atualizar/:id',
      component: Edit,
      name: 'providerEdit',
      meta: {
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'provider', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/provider/routes.js